import { createFileRoute } from "@tanstack/react-router";
import AdminVideoPages from "@/pages/admin/AdminVideoPages";

export const Route = createFileRoute("/_adminLayout/admin/video-pages")({
  component: AdminVideoPages,
});
